import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Users, Target } from 'lucide-react';
import { Card } from '../../ui/card';

const MarketSlide = ({ data }) => {
  return (
    <div className="w-full max-w-6xl mx-auto">
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-10"
      >
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">{data.title}</h2>
        <p className="text-xl text-slate-400">{data.subtitle}</p>
      </motion.div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
        {data.stats.map((stat, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 + index * 0.1 }}
          >
            <Card className="bg-gradient-to-br from-slate-800/80 to-slate-900/80 border-cyan-500/20 p-6 text-center">
              <div className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-cyan-400 to-teal-400 bg-clip-text text-transparent mb-2">
                {stat.value}
              </div>
              <p className="text-slate-300 mb-2">{stat.label}</p>
              <div className="inline-flex items-center gap-1 px-3 py-1 bg-emerald-500/20 rounded-full">
                <TrendingUp className="w-3 h-3 text-emerald-400" />
                <span className="text-xs text-emerald-400 font-medium">{stat.growth}</span>
              </div>
            </Card>
          </motion.div>
        ))}
      </div>

      {/* Target Segments */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
      >
        <Card className="bg-slate-800/30 border-slate-700/50 p-6">
          <div className="flex items-center gap-3 mb-4">
            <Target className="w-6 h-6 text-cyan-400" />
            <h3 className="text-xl font-semibold text-white">Target Segments</h3>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {data.targetSegments.map((segment, index) => (
              <div
                key={index}
                className="flex items-center gap-2 p-3 bg-slate-700/30 rounded-lg"
              >
                <Users className="w-4 h-4 text-teal-400 shrink-0" />
                <span className="text-slate-300 text-sm">{segment}</span>
              </div>
            ))}
          </div>
        </Card>
      </motion.div>
    </div>
  );
};

export default MarketSlide;
